import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ArticleCard from '@/components/feature/ArticleCard';
import { articles, categories } from '@/mocks/articles';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const [activeCategory, setActiveCategory] = useState(slug || 'all');

  useEffect(() => {
    if (slug) {
      setActiveCategory(slug);
    }
  }, [slug]);

  const currentCategory = categories.find(c => c.slug === activeCategory);
  const categoryName = currentCategory?.name || '全部';

  const filteredArticles = activeCategory === 'all'
    ? articles
    : articles.filter(a => a.categorySlug === activeCategory);

  useEffect(() => {
    document.title = `${categoryName} - 51cg吃瓜网 | 51cgfun今日吃瓜`;
  }, [categoryName]);

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    'name': `${categoryName} - 51cg吃瓜网`,
    'description': `51cg吃瓜网${categoryName}频道，提供最新${categoryName}相关资讯和热门吃瓜内容。`,
    'url': `https://51cg.fun/category/${activeCategory}`,
    'inLanguage': 'zh-CN',
    'isPartOf': {
      '@type': 'WebSite',
      'name': '51cg吃瓜网',
      'url': 'https://51cg.fun',
    },
  };

  return (
    <>
      <ScrollToTop />
      <Navbar />

      <main className="pt-16">
        <div className="bg-background-100 border-b border-background-200/60">
          <div className="max-w-7xl mx-auto px-4 md:px-6 py-8">
            <div className="mb-4">
              <Breadcrumb
                items={[
                  { label: '首页', href: '/' },
                  { label: categoryName },
                ]}
              />
            </div>
            <h1 className="text-2xl md:text-3xl font-heading text-foreground-900">
              51cg<span className="text-primary-500">·</span>{categoryName}
            </h1>
            <p className="text-sm text-foreground-500 mt-2">
              共 {filteredArticles.length} 篇吃瓜文章 · 紧跟朝阳群众吃瓜动态
            </p>
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 md:px-6 py-6">
          <div className="flex items-center gap-2 overflow-x-auto scrollbar-hide pb-2">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 text-sm font-medium rounded-full transition-colors whitespace-nowrap ${
                  activeCategory === cat.slug
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                }`}
              >
                {cat.name}
              </Link>
            ))}
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 md:px-6 pb-14">
          {filteredArticles.length > 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
              {filteredArticles.map((article) => (
                <ArticleCard key={article.id} article={article} />
              ))}
            </div>
          ) : (
            <div className="text-center py-20">
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-background-100">
                <i className="ri-emotion-sad-line text-foreground-400 text-2xl"></i>
              </div>
              <p className="text-foreground-500 text-sm">该分类下暂无文章，请查看其他分类</p>
              <Link
                to="/category/all"
                className="inline-block mt-4 px-6 py-2 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                查看全部文章
              </Link>
            </div>
          )}
        </div>
      </main>

      <Footer />
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
    </>
  );
}